import React, { useState } from 'react';
import StudentTemplate from "../../component/StudentTemplate";
import { ToastContainer, toast } from "react-toastify";

const Academiccredit = () => {
  // 1. State Management
  const [formData, setFormData] = useState({
    courseName: '',
    category: '',
    nheqfLevel: '',
    credits: '',
    document: null,
  });

  const [isSubmitted, setIsSubmitted] = useState(false);

  // --- NEW: State to hold list of applied courses (with some dummy data for demo) ---
  const [applications, setApplications] = useState([
    {
      id: 101,
      courseName: 'Introduction to Python',
      category: 'SEC',
      nheqfLevel: '4.5',
      credits: '3',
      status: 'Approved',
      date: '2024-01-10',
      documentName: 'python_cert.pdf'
    },
    {
      id: 102,
      courseName: 'Environmental Studies',
      category: 'VAC',
      nheqfLevel: '5',
      credits: '2',
      status: 'Rejected',
      date: '2024-01-12',
      documentName: 'env_doc.jpg'
    }
  ]);

  // 2. Data Lists
  const categories = ['Major', 'Minor', 'MDC', 'MDE', 'SDC', 'MPC', 'AEC', 'VAC', 'SEC'];

  const nheqfLevels = [
    { value: '4.5', label: 'Level 4.5 (Certificate)' },
    { value: '5', label: 'Level 5 (Diploma)' },
    { value: '5.5', label: 'Level 5.5 (Advanced Diploma)' },
    { value: '6', label: 'Level 6 (Bachelors)' },
    { value: '7', label: 'Level 7 (Bachelors with Research/Honors)' },
    { value: '8', label: 'Level 8 (Masters/Doctoral path)' },
  ];

  const creditOptions = [4, 3, 2, 1];

  // 3. Handlers
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    if (e.target.files && e.target.files[0]) {
      setFormData((prev) => ({ ...prev, document: e.target.files[0] }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Create a new application object
    const newApplication = {
      id: Date.now(), // unique id
      ...formData,
      status: 'Pending', // Default status
      date: new Date().toISOString().split('T')[0], // Current date
      documentName: formData.document ? formData.document.name : 'No file'
    };

    // Add to the list (Newest first)
    setApplications([newApplication, ...applications]);

    console.log('Form Submitted:', formData);
    toast.success('Course details submitted successfully!');
    setIsSubmitted(true);
  };

  // Helper to get color based on status
  const getStatusBadge = (status) => {
    switch (status) {
      case 'Approved': return 'bg-success bg-opacity-10 text-success border border-success';
      case 'Rejected': return 'bg-danger bg-opacity-10 text-danger border border-danger';
      default: return 'bg-warning bg-opacity-10 text-warning border border-warning'; // Pending
    }
  };

  const resetForm = () => {
    setIsSubmitted(false);
    setFormData({
      courseName: '',
      category: '',
      nheqfLevel: '',
      credits: '',
      document: null,
    });
  };

  // 4. Render
  if (isSubmitted) {
    return (
      <StudentTemplate>
        <div className="d-flex align-items-center justify-content-center bg-light py-5" style={{ minHeight: '80vh' }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-5 col-md-7">
                <div className="card border-0 shadow rounded-4">
                  <div className="card-body text-center p-5">
                    <div className="mb-4">
                      <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center" style={{ width: '80px', height: '80px' }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" className="bi bi-check-lg text-success" viewBox="0 0 16 16">
                          <path d="M12.736 3.97a.733.733 0 0 1 1.047 0c.286.289.29.756.01 1.05L7.88 12.01a.733.733 0 0 1-1.065.02L3.217 8.384a.757.757 0 0 1 0-1.06.733.733 0 0 1 1.047 0l3.052 3.093 5.4-6.425a.247.247 0 0 1 .02-.022Z" />
                        </svg>
                      </div>
                    </div>
                    <h3 className="fw-bold mb-2 text-dark">Submission Successful!</h3>
                    <p className="text-muted mb-4">Your course details have been recorded and are now pending approval.</p>

                    <button onClick={resetForm} className="btn btn-primary w-100 rounded-pill py-3 fw-bold shadow-sm">
                      Go Back to Dashboard
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </StudentTemplate>
    );
  }

  return (
    <>
      <StudentTemplate>
        <ToastContainer position="top-right" autoClose={3000} />

        <div className="col-12 mb-0 order-5 order-md-5">
          <div className="card tranaction-card">
            <div className="card-header card-no-border">

              {/* Hero Section */}
              <div className="bg-gradient py-5" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                <div className="container">
                  <div className="row justify-content-center text-center text-white">
                    <div className="col-lg-8">
                      <h2 className="fw-bold mb-2 text-black">Academic Credit Registration</h2>
                      
                    </div>
                  </div>
                </div>
              </div>

              <div className="container py-5" style={{ marginTop: '-40px' }}>
                <div className="row justify-content-center g-4">

                  {/* Left Column: Form */}
                  <div className="col-lg-5">
                    <div className="card border-0 shadow rounded-3 h-100">
                      <div className="card-header bg-white border-0 pt-4 px-4 pb-0">
                        <h5 className="fw-bold text-primary mb-0">
                          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" className="bi bi-plus-circle-fill me-2" viewBox="0 0 16 16">
                            <path d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0M8.5 4.5a.5.5 0 0 0-1 0v3h-3a.5.5 0 0 0 0 1h3v3a.5.5 0 0 0 1 0v-3h3a.5.5 0 0 0 0-1h-3z" />
                          </svg>
                          New Application
                        </h5>
                      </div>
                      <div className="card-body p-4">
                        <form onSubmit={handleSubmit}>
                          {/* Course Name */}
                          <div className="mb-3">
                            <label htmlFor="courseName" className="form-label fw-semibold small">Course Name <span className="text-danger">*</span></label>
                            <input type="text" className="form-control bg-light border-0" id="courseName" name="courseName"
                              placeholder="e.g. Data Science" value={formData.courseName} onChange={handleChange} required />
                          </div>

                          <div className="row g-2">
                            <div className="col-md-6">
                              <label htmlFor="category" className="form-label fw-semibold small">Category <span className="text-danger">*</span></label>
                              <select className="form-select bg-light text-black  border-0" id="category" name="category" value={formData.category} onChange={handleChange} required>
                                <option value="">Select...</option>
                                {categories.map((cat) => <option key={cat} value={cat}>{cat}</option>)}
                              </select>
                            </div>
                            <div className="col-md-6">
                              <label htmlFor="nheqfLevel" className="form-label fw-semibold small">Level <span className="text-danger">*</span></label>
                              <select className="form-select  bg-light text-black  border-0" id="nheqfLevel" name="nheqfLevel" value={formData.nheqfLevel} onChange={handleChange} required>
                                <option value="">Select...</option>
                                {nheqfLevels.map((l) => <option key={l.value} value={l.value}>{l.value}</option>)}
                              </select>
                            </div>
                          </div>

                          <div className="my-3">
                            <label className="form-label fw-semibold small mb-2">Credits <span className="text-danger">*</span></label>
                            <div className="d-flex gap-2">
                              {creditOptions.map((credit) => (
                                <div className="flex-grow-1" key={credit}>
                                  <input type="radio" className="btn-check" name="credits" id={`credit-${credit}`}
                                    value={credit} checked={formData.credits === String(credit)} onChange={handleChange} required />
                                  <label className="btn btn-outline-primary w-100 border-2 py-1" htmlFor={`credit-${credit}`}>
                                    <small className="fw-bold">{credit}</small>
                                  </label>
                                </div>
                              ))}
                            </div>
                          </div>

                          <div className="mb-4">
                            <label className="form-label fw-semibold small">Document</label>
                            <input type="file" className="form-control form-control-sm" onChange={handleFileChange} accept=".pdf,.jpg,.png" />
                            {formData.document && <small className="text-success d-block mt-1"><i className="bi bi-check"></i> {formData.document.name}</small>}
                          </div>

                          <button type="submit" className="btn btn-primary w-100 rounded-pill fw-semibold shadow-sm">
                            Submit Application
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* Right Column: Application Status List (NEW SECTION) */}
                  <div className="col-lg-7">
                    <div className="card border-0 shadow rounded-3 h-100">
                      <div className="card-header bg-white border-0 pt-4 px-4 pb-0 d-flex justify-content-between align-items-center">
                        <h5 className="fw-bold text-dark mb-0">

                          Application History
                        </h5>

                      </div>

                      <div className="card-body p-4">
                        {applications.length === 0 ? (
                          <div className="text-center text-muted py-5">
                            <p>No applications submitted yet.</p>
                          </div>
                        ) : (
                          <div className="d-flex flex-column gap-3">
                            {applications.map((app) => (
                              <div key={app.id} className="card border rounded-3 overflow-hidden hover-shadow transition-all">
                                <div className="card-body p-3">
                                  <div className="row align-items-center">
                                    {/* Icon & Basic Info */}
                                    <div className="col-md-7 mb-2 mb-md-0">
                                      <div className="d-flex align-items-center">
                                        <div className="bg-light rounded-3 p-2 me-3 text-center" style={{ minWidth: '50px' }}>
                                          <span className="d-block fw-bold text-dark h5 mb-0">{app.credits}</span>
                                          <small className="text-muted" style={{ fontSize: '10px' }}>CREDIT</small>
                                        </div>
                                        <div>
                                          <h6 className="fw-bold text-dark mb-1">{app.courseName}</h6>
                                          <div className="d-flex gap-2 text-muted small">
                                            <span><span className="fw-semibold text-dark">Cat:</span> {app.category}</span>
                                            <span className="border-start ps-2"><span className="fw-semibold text-dark">Lvl:</span> {app.nheqfLevel}</span>
                                            <span className="border-start ps-2">{app.date}</span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    {/* Status & Actions */}
                                    <div className="col-md-5 text-md-end">
                                      <div className="d-flex align-items-center justify-content-md-end gap-2">
                                        {/* Document Indicator */}
                                        {app.documentName && (
                                          <span className="badge bg-light text-secondary border fw-normal" title={app.documentName}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-paperclip" viewBox="0 0 16 16">
                                              <path d="M4.5 3a2.5 2.5 0 0 1 5 0v9a1.5 1.5 0 0 1-3 0V5a.5.5 0 0 1 1 0v7a.5.5 0 0 0 1 0V3a1.5 1.5 0 1 0-3 0v9a2.5 2.5 0 0 0 5 0V5a.5.5 0 0 1 1 0v7a3.5 3.5 0 1 1-7 0V3z" />
                                            </svg>
                                          </span>
                                        )}

                                        {/* Status Badge */}
                                        <span className={`badge rounded-pill px-3 py-2 text-black ${getStatusBadge(app.status)}`}>
                                          {app.status === 'Pending' && <span className="spinner-grow spinner-grow-sm me-2" role="status" aria-hidden="true" style={{ width: '0.5rem', height: '0.5rem' }}></span>}
                                          {app.status}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* Progress bar visual for Pending items */}
                                {app.status === 'Pending' && (
                                  <div className="progress" style={{ height: '3px' }}>
                                    <div className="progress-bar progress-bar-striped progress-bar-animated bg-warning" role="progressbar" style={{ width: '40%' }}></div>
                                  </div>
                                )}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </div>
      </StudentTemplate>
    </>
  );
};

export default Academiccredit;